import GetDataRequest from '../entities/GetDataRequest'
export class LogMessageFilter {
    
    public RequestID?: number;
    public StartDate?: Date;
    public EndDate?: Date;
    GetDataRequest: GetDataRequest;
}

export default LogMessageFilter;